import React from "react";

export default function MySQL_ASCII() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_ASCII</h1>
      <p>This is the MySQL_ASCII component generated from the SQL JSON.</p>
    </div>
  );
}
